export {
    default as Dialog
}
from './dialog'